$ = jQuery;
var tm_cookie_url = 'https://tm-cookie.eager.ly';
function checkCookies() {
	//additional check for cookietool preferences
	var tracking = getCookie( 'cookie_settings' );
	if ( tracking && tracking.indexOf( 'tracking' ) !== -1 ) {
		tracking = true;
	} else {
		tracking = false;
	}
	// COOKIE CHECKER: http://stackoverflow.com/questions/3550790/check-if-third-party-cookies-are-enabled
	if( $('iframe[src*="ticketmatic.com/"]').length > 0 ) {
		if ( $('html.mobile').length > 0 ) {
			var src = $('iframe[src*="ticketmatic.com/"]').attr( 'src' );
			$('iframe[src*="ticketmatic.com/"]').remove();
			$('.the-content:first').prepend('<div id="show" style="display:block;padding:50px"><h1>Cookies</h1><h3>Uw instellingen blokkeren cookies, u wordt doorverwezen naar een nieuw scherm!</h3></div>');
			setTimeout(function(){
				window.open(src, '_self');
			},3000);
		}else if ( navigator.cookieEnabled ){
			// do nothing
			var script = document.createElement("script");
			script.setAttribute("type", "text/javascript");
			script.setAttribute("src", tm_cookie_url + "/cookietest/step1.php");
			document.body.appendChild(script);

			window._3rd_party_test_step1_loaded = function(){
			  var step2Url = tm_cookie_url + '/cookietest/step2.php',
			    resultsEl = document.getElementById('3rd_party_cookie_test_results'),
			    step2El = document.createElement('script');
			  // And load the second part of the test (reading the cookie)
			  step2El.setAttribute('src', step2Url);
			  resultsEl.appendChild(step2El);
			}
			window._3rd_party_test_step2_loaded = function(cookieSuccess){
			  var resultsEl = document.getElementById('3rd_party_cookie_test_results'),
			    errorEl = document.getElementById('3rd_party_cookie_test_error');
			  // Show message
			  if( ! cookieSuccess || ! tracking ) {
			  	var src = $('iframe[src*="ticketmatic.com/"]').attr( 'src' );
			  	$('iframe[src*="ticketmatic.com/"]').remove();
					$('.the-content:first').prepend('<div id="show" style="display:block;padding:50px"><h1>Cookies</h1><h3>Uw instellingen blokkeren cookies, u wordt doorverwezen naar een nieuw scherm!</h3></div>');
					setTimeout(function(){
			  		window.open(src, '_self');
			  	},3000);
		    }
			}

		} else {
			$('iframe[src*="ticketmatic.com/"]').remove();
			$('.the-content:first').prepend('<div id="show" style="display:block;padding:50px"><h1>Cookies</h1><h3>U dient cookies in te schakelen om tickets te kunnen bestellen!</h3></div>');
		}
	}
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
